/**
 * This function generates the Form part: Address. This parts contains several fields like zip, city, street
 * and so on.
 *
 * @param {Object} context - The context in which the function is called. This is normally FormViewer.js.
 * @param {HTMLTableRowElement} tr - The TableRowElement in which the content should be rendered.
 * @param {Object} data - Th data for generate process
 */

function genAddress(context, tr, data) {
  const that = context;
  const addressElements = [];
  const td = document.createElement("td");
  tr.appendChild(td);

  td.insertAdjacentHTML(
    "beforeend",
    `
                <div>
                    <input type="number" class="awesomplete" ${
                      data.meta.required ? "required" : ""
                    } autocomplete="off"  maxLength="5"  name="postalCode" placeholder="${lng.get(
      "form-input-address-postalCode"
    )}" />
                    <input class="awesomplete" ${
                      data.meta.required ? "required" : ""
                    }  autocomplete="off" name="city" placeholder="${lng.get(
      "form-input-address-city"
    )}" />

                </div>
                <div>
                    <input class="awesomplete" ${
                      data.meta.required ? "required" : ""
                    } autocomplete="off" name="street" placeholder="${lng.get(
      "form-input-address-street"
    )}" />
                    <input type="number" ${
                      data.meta.required ? "required" : ""
                    } autocomplete="off" maxLength="10" name="houseNumber" placeholder="${lng.get(
      "form-input-address-houseNumber"
    )}" />
                    <input type="text" maxLength="5" autocomplete="off" name="houseNumberExtra" placeholder="${lng.get(
                      "form-input-address-houseNumberExtra"
                    )}" />
                </div>
            `
  );
  // get all elements an add js listener
  const streetInputElem = td.querySelector('input[name="street"]');
  const cityInputElem = td.querySelector('input[name="city"]');
  const postalCodeInputElem = td.querySelector('input[name="postalCode"]');

  // awsomplete initializing
  streetInputElem.awsomplete = new Awesomplete(streetInputElem, {
    minChars: 0,
    maxItems: 15,
  });
  cityInputElem.awsomplete = new Awesomplete(cityInputElem, {
    minChars: 0,
    maxItems: 15,
  });
  postalCodeInputElem.awsomplete = new Awesomplete(postalCodeInputElem, {
    minChars: 0,
    maxItems: 15,
  });

  addressElements.push(postalCodeInputElem);
  addressElements.push(cityInputElem);
  addressElements.push(streetInputElem);
  addressElements.push(td.querySelector('input[name="houseNumber"]'));
  addressElements.push(td.querySelector('input[name="houseNumberExtra"]'));

  addressElements.forEach((elem) => {
    //maxLength exist
    if (elem.getAttribute("maxLength")) {
      elem.addEventListener("input", (e) => {
        //max length is properly not supported in devices ...
        if (e.target.value.length >= e.target.getAttribute("maxLength")) {
          e.target.value = e.target.value.slice(
            0,
            e.target.getAttribute("maxLength")
          );
        }
      });
    }
  });

  // postalcode validation (special treatment)
  postalCodeInputElem.addEventListener("input", (event) => {
    isZipValid(event.target.value);
  });

  // support zip function
  function isZipValid(value) {
    var regEx = new RegExp("^\\d{5}$");

    if (regEx.test(value)) {
      postalCodeInputElem.setCustomValidity("");
      return true;
    } else {
      postalCodeInputElem.setCustomValidity(
        `${lng.get("form-input-address-invalid-zip-no-digits")}`
      );
      return false;
    }
  }

  // checkboxes logic
  if (data.meta.epaper) {
    var checkboxContainer = document.createElement("div");
    checkboxContainer.classList.add("checkbox-container");

    checkboxContainer.insertAdjacentHTML(
      "beforeend",
      `<div class="checkbox-wrapper">
                        <label>${lng.get("form-input-address-print")}
                            <input type="checkbox" name="print">
                            <div class="checkbox-img"></div>
                        </label>
                    </div>
                    <div class="checkbox-wrapper">
                        <label>${lng.get("form-input-address-epaper")}
                            <input type="checkbox" name="epaper">
                            <div class="checkbox-img"></div>
                        </label>
                    </div>`
    );
    var epaperCheckbox2 = checkboxContainer.querySelector("input[name=epaper]");
    var printCheckbox2 = checkboxContainer.querySelector("input[name=print]");
    epaperCheckbox2.container = checkboxContainer;
    printCheckbox2.container = checkboxContainer;

    printCheckbox2.classList.container = checkboxContainer;
    printCheckbox2.classList.add = function (item) {
      this.container.classList.add(item);
    };
    printCheckbox2.classList.remove = function (item) {
      this.container.classList.remove(item);
    };
    epaperCheckbox2.classList.container = checkboxContainer;
    epaperCheckbox2.classList.add = function (item) {
      this.container.classList.add(item);
    };
    epaperCheckbox2.classList.remove = function (item) {
      this.container.classList.remove(item);
    };

    epaperCheckbox2.setCustomValidity("Bitte wählen Sie eines der Felder aus.");
    printCheckbox2.setCustomValidity("Bitte wählen Sie eines der Felder aus.");
    epaperCheckbox2.addEventListener("change", function () {
      var printBox = this.container.querySelector("input[name=print]");
      this.container.classList.remove("valid");
      this.container.classList.remove("not-valid");
      if (this.checked) {
        if (that.contactmail) that.contactmail.required = true;
        this.container.classList.add("valid");
        this.setCustomValidity("");
        printBox.setCustomValidity("");
      } else {
        if (that.contactmail) that.contactmail.required = false;
        if (printBox.checked) {
          this.container.classList.add("valid");
          this.setCustomValidity("");
          printBox.setCustomValidity("");
        } else {
          this.container.classList.add("not-valid");
          this.setCustomValidity("Bitte wählen Sie eines der Felder aus.");
          printBox.setCustomValidity("Bitte wählen Sie eines der Felder aus.");
        }
      }
    });

    printCheckbox2.addEventListener("change", function () {
      const epaperBox = this.container.querySelector("input[name=epaper]");
      this.container.classList.remove("valid");
      this.container.classList.remove("not-valid");
      if (this.checked) {
        if (!epaperBox.checked) {
          if (that.contactmail) that.contactmail.required = false;
        }
        this.container.classList.add("valid");
        this.setCustomValidity("");
        epaperBox.setCustomValidity("");
      } else {
        if (epaperBox.checked) {
          if (that.contactmail) that.contactmail.required = true;
          this.container.classList.add("valid");
          this.setCustomValidity("");
          epaperBox.setCustomValidity("");
        } else {
          if (that.contactmail) that.contactmail.required = false;

          this.container.classList.add("not-valid");
          this.setCustomValidity("Bitte wählen Sie eines der Felder aus.");
          epaperBox.setCustomValidity("Bitte wählen Sie eines der Felder aus.");
        }
      }
    });
    // --- mock radio button behavior if necessary ---
    if (data.meta.eitherOr) {
      var epaperCheckbox2 =
        checkboxContainer.querySelector("input[name=epaper]");
      var printCheckbox2 = checkboxContainer.querySelector("input[name=print]");
      epaperCheckbox2.addEventListener(
        "click",
        () => (printCheckbox2.checked = false)
      );
      printCheckbox2.addEventListener(
        "click",
        () => (epaperCheckbox2.checked = false)
      );
    }

    td.appendChild(checkboxContainer);
  }

  // optional logic treatment
  if (data.meta.checkPostalCode) {
    if (that.streetRecords != null && that.deliveryAreas != null) {
      let areas = [];
      let cities = [];
      let streets = [];

      if (data.meta.epaper) {
        var printCheckbox = td.querySelector('input[name="print"]').parentNode;
        var epaperCheckbox = td.querySelector(
          'input[name="epaper"]'
        ).parentNode;
      }

      // --- event listener
      function postalCodeInputEvent(event) {
        // if empty -> reset
        if (event.target.value.length === 0) {
          availabilityPrintAndEpaper(true, true);
          td.querySelector('input[name="city"]').awsomplete.list = [];
          cityInputElem.value = "";
          td.querySelector('input[name="street"]').awsomplete.list = [];
          streetInputElem.value = "";
          cities = [];
          streets = [];
        }
        // 5 ciphers
        if (event.target.value.length === 5 && isZipValid(event.target.value)) {
          cityInputElem.value = "";
          streetInputElem.value = "";
          if (validEntry(that.deliveryAreas, "^" + event.target.value + "$")) {
            // if valid zip
            // get available areas
            areas = that.streetRecords.filter(
              (area) => area.zip === event.target.value
            );

            if (areas.length === 0) {
              td.querySelector('input[name="street"]').awsomplete.list = [];
            }

            createAvailableCities();
            availabilityPrintAndEpaper(true, true);
            postalCodeInputElem.setCustomValidity("");
          } else {
            // if no valid zip
            if (data.meta.epaperEverywhere) {
              // if epaper everywhere is active -> plz is valid
              postalCodeInputElem.setCustomValidity("");
              // get available areas (case: german street records)
              areas = that.streetRecords.filter(
                (area) => area.zip === event.target.value
              );

              createAvailableCities();
              availabilityPrintAndEpaper(false, true);
            } else {
              // if epaper is not every active -> plz is not valid
              postalCodeInputElem.setCustomValidity(
                `${lng.get("form-input-address-invalid-zip")}`
              );
              availabilityPrintAndEpaper(false, false);
            }
          }
        }
      }

      postalCodeInputElem.addEventListener("input", (event) => {
        postalCodeInputEvent(event);
      });
      postalCodeInputElem.addEventListener(
        "awesomplete-selectcomplete",
        (event) => {
          postalCodeInputEvent(event);
        }
      );

      function cityInputEvent(event) {
        // if empty -> reset
        if (event.target.value.length === 0) {
          removeStreets();
          streets = [];
          streetInputElem.value = "";
        }
        // if no cities available no validation
        if (cities.length !== 0) {
          // if city is valid
          insertCities(event.target.value);
          if (
            validEntry(cities, "^" + event.target.value.toLowerCase() + "$")
          ) {
            cityInputElem.setCustomValidity("");
            removeCities(); //new
            createAvailableStreets();
            streetInputElem.value = "";
          } else {
            cityInputElem.setCustomValidity(
              `${lng.get("form-input-address-invalid-city")}`
            );
          }
        } else {
          cityInputElem.setCustomValidity("");
        }
      }

      cityInputElem.addEventListener("input", (event) => {
        cityInputEvent(event);
      });
      cityInputElem.addEventListener("awesomplete-selectcomplete", (event) => {
        cityInputEvent(event);
      });

      function streetInputEvent(event) {
        // if no streets -> no validation
        if (streets.length !== 0) {
          insertStreets(event.target.value);
          if (
            validEntry(streets, "^" + event.target.value.toLowerCase() + "$")
          ) {
            streetInputElem.blur();
            streetInputElem.setCustomValidity("");
            removeStreets(); //new
          } else {
            streetInputElem.setCustomValidity(
              `${lng.get("form-input-address-invalid-street")}`
            );
          }
        } else {
          streetInputElem.setCustomValidity("");
        }
      }

      streetInputElem.addEventListener("input", (event) => {
        streetInputEvent(event);
      });

      streetInputElem.addEventListener("focusout", (event) => {
        const searchStreet = streets.find(
          (street) =>
            street.toLocaleLowerCase() ===
            event.target.value.toLocaleLowerCase()
        );
        if (searchStreet) {
          event.target.value = searchStreet;
        }
      });

      streetInputElem.addEventListener(
        "awesomplete-selectcomplete",
        (event) => {
          streetInputEvent(event);
        }
      );

      // support functions
      function removeCities() {
        // remove old list
        const oldDatalist = td.querySelector("#city_datalist");
        if (oldDatalist) oldDatalist.remove();
      }

      function removeStreets() {
        // remove old list
        const oldDatalist = td.querySelector("#street_datalist");
        if (oldDatalist) oldDatalist.remove();
      }

      // support function to hide or show print / epaper checkboxes
      function availabilityPrintAndEpaper(print, epaper) {
        if (data.meta.epaper) {
          if (print) {
            printCheckbox.classList.remove("hide");
          } else {
            printCheckbox.classList.add("hide");
          }

          if (epaper) {
            epaperCheckbox.classList.remove("hide");
          } else {
            epaperCheckbox.classList.add("hide");
          }

          tr.resetElement(false);
        }
      }

      function createAvailableStreets() {
        streets = [];

        // get rid of duplicates
        if (areas.length > 0) {
          const selectedZip = areas[0].zip;
          const filteredStreets = that.streetRecords.find(
            (row) => row.zip === selectedZip && row.city === cityInputElem.value
          );
          if (filteredStreets) {
            streets = filteredStreets.streets;
          }
        }
        insertStreets();
      }

      function createAvailableCities() {
        cities = [];
        // get rid of duplicates
        areas.forEach((area) => {
          if (typeof cities.find((item) => item === area.city) == "undefined") {
            cities.push(area.city);
          }
        });
        insertCities(null, true);
      }

      function insertCities(input, insert) {
        // remove old list
        //removeCities();
        // create datalist
        let tmpCities;
        if (input) {
          // if input is not undefined use regex
          tmpCities = cities.filter((city) => {
            const regEx = new RegExp("^" + input.toLowerCase() + ".*$");
            return regEx.test(city.toLowerCase());
          });
        } else {
          // if input is undefined take all cities
          tmpCities = cities;
        }
        /*var options = tmpCities.map(item => `<option label="" value="${item}">${item}</option>`).join("");
                var datalist = document.createElement("datalist");
                datalist.id = "city_datalist";
                datalist.innerHTML = options
                td.appendChild(datalist);*/
        td.querySelector('input[name="city"]').awsomplete.list = tmpCities;

        // if just one city is available
        if (tmpCities.length === 1 && insert) {
          cityInputElem.value = tmpCities[0];
          cityInputElem.setCustomValidity("");
          createAvailableStreets();
          streetInputElem.value = "";
        }
      }

      function insertStreets(input) {
        // remove old list
        //removeStreets();
        // create datalist
        let tmpStreets;
        if (input) {
          // if input is not undefined use regex
          tmpStreets = streets.filter((street) => {
            const regEx = new RegExp("^" + input.toLowerCase() + ".*$");
            return regEx.test(street.toLowerCase());
          });
        } else {
          // if input is undefined take all streets
          tmpStreets = streets;
        }

        td.querySelector('input[name="street"]').awsomplete.list = tmpStreets;
      }

      function validEntry(array, regEx) {
        return array.some((item) => {
          const regex = new RegExp(regEx);
          return regex.test(item.toLowerCase());
        });
      }

      postalCodeInputElem.awsomplete.list = that.deliveryAreas;
    } else {
      // some error outputs if street or ares could not be loaded
      if (that.streetRecords == null && that.deliveryAreas == null)
        snackbar.show({
          message: `${lng.get("form-no-areas-and-no-records")}`,
        });
      else if (that.streetRecords == null)
        snackbar.show({ message: `${lng.get("form-no-street-records")}` });
      else snackbar.show({ message: `${lng.get("form-no-delivery-areas")}` });
    }
  } else {
    streetInputElem.addEventListener("input", function () {
      this.setCustomValidity("");
    });
    cityInputElem.addEventListener("input", function () {
      this.setCustomValidity("");
    });
    if (that.streetRecords != null && that.deliveryAreas != null) {
      let areas = [];
      let cities = [];
      let streets = [];

      function postalCodeInputEvent(event) {
        // if empty -> reset
        if (event.target.value.length === 0) {
          td.querySelector('input[name="city"]').awsomplete.list = [];
          cityInputElem.value = "";
          td.querySelector('input[name="street"]').awsomplete.list = [];
          streetInputElem.value = "";
          cities = [];
          streets = [];
        }
        // 5 ciphers
        if (isZipValid(event.target.value)) {
          cityInputElem.value = "";
          streetInputElem.value = "";
          if (validEntry(that.deliveryAreas, "^" + event.target.value + "$")) {
            // if valid zip
            // get available areas
            areas = that.streetRecords.filter(
              (area) => area.zip === event.target.value
            );

            if (areas.length === 0) {
              // No areas where found -> remove the street list
              td.querySelector('input[name="street"]').awsomplete.list = [];
            }

            createAvailableCities();
            postalCodeInputElem.setCustomValidity("");
          } else {
            // if no valid zip
            // if epaper everywhere is active -> plz is valid
            //postalCodeInputElem.setCustomValidity('');
            // get available areas (case: german street records)
            areas = that.streetRecords.filter(
              (area) => area.zip === event.target.value
            );
            createAvailableCities();
          }
        }
      }

      postalCodeInputElem.addEventListener("input", (event) => {
        postalCodeInputEvent(event);
      });
      postalCodeInputElem.addEventListener(
        "awesomplete-selectcomplete",
        (event) => {
          postalCodeInputEvent(event);
        }
      );

      function cityInputEvent(event) {
        // if empty -> reset
        if (event.target.value.length === 0) {
          removeStreets();
          streets = [];
          streetInputElem.value = "";
        }
        // if no cities available no validation
        if (cities.length !== 0) {
          // if city is valid
          insertCities(event.target.value);
          if (
            validEntry(cities, "^" + event.target.value.toLowerCase() + "$")
          ) {
            cityInputElem.setCustomValidity("");
            removeCities(); //new
            createAvailableStreets();
            streetInputElem.value = "";
          }
        } else {
          cityInputElem.setCustomValidity("");
        }
      }

      cityInputElem.addEventListener("input", (event) => {
        cityInputEvent(event);
      });
      cityInputElem.addEventListener("awesomplete-selectcomplete", (event) => {
        cityInputEvent(event);
      });

      function streetInputEvent(event) {
        // if no streets -> no validation
        if (streets.length !== 0) {
          insertStreets(event.target.value);
          if (
            validEntry(streets, "^" + event.target.value.toLowerCase() + "$")
          ) {
            streetInputElem.blur();
            streetInputElem.setCustomValidity("");
            removeStreets(); //new
          }
        } else {
          streetInputElem.setCustomValidity("");
        }
      }

      streetInputElem.addEventListener("focusout", (event) => {
        const searchStreet = streets.find(
          (street) =>
            street.toLocaleLowerCase() ===
            event.target.value.toLocaleLowerCase()
        );
        if (searchStreet) {
          event.target.value = searchStreet;
        }
      });

      streetInputElem.addEventListener("input", (event) => {
        streetInputEvent(event);
      });
      streetInputElem.addEventListener(
        "awesomplete-selectcomplete",
        (event) => {
          streetInputEvent(event);
        }
      );

      function removeCities() {
        // remove old list
        const oldDatalist = td.querySelector("#city_datalist");
        if (oldDatalist) oldDatalist.remove();
      }

      function removeStreets() {
        // remove old list
        const oldDatalist = td.querySelector("#street_datalist");
        if (oldDatalist) oldDatalist.remove();
      }

      function createAvailableStreets() {
        streets = [];
        // get rid of duplicates
        if (areas.length > 0) {
          const selectedZip = areas[0].zip;
          const filteredStreets = that.streetRecords.find(
            (row) => row.zip === selectedZip && row.city === cityInputElem.value
          );
          if (filteredStreets) {
            streets = filteredStreets.streets;
          }
        }
        insertStreets();
      }

      function createAvailableCities() {
        cities = [];
        // get rid of duplicates
        areas.forEach((area) => {
          if (typeof cities.find((item) => item === area.city) == "undefined") {
            cities.push(area.city);
          }
        });
        insertCities(null, true);
      }

      function insertCities(input, insert) {
        // remove old list
        //removeCities();
        // create datalist
        let tmpCities;
        if (input) {
          // if input is not undefined use regex
          tmpCities = cities.filter((city) => {
            const regEx = new RegExp("^" + input.toLowerCase() + ".*$");
            return regEx.test(city.toLowerCase());
          });
        } else {
          // if input is undefined take all cities
          tmpCities = cities;
        }

        td.querySelector('input[name="city"]').awsomplete.list = tmpCities;

        // if just one city is available
        if (tmpCities.length === 1 && insert) {
          cityInputElem.value = tmpCities[0];
          createAvailableStreets();
          streetInputElem.value = "";
        }
      }

      function insertStreets(input) {
        // remove old list
        //removeStreets();
        // create datalist
        let tmpStreets;
        if (input) {
          // if input is not undefined use regex
          tmpStreets = streets.filter((street) => {
            const regEx = new RegExp("^" + input.toLowerCase() + ".*$");
            return regEx.test(street.toLowerCase());
          });
        } else {
          // if input is undefined take all streets
          tmpStreets = streets;
        }

        td.querySelector('input[name="street"]').awsomplete.list = tmpStreets;
      }

      function validEntry(array, regEx) {
        return array.some((item) => {
          const regex = new RegExp(regEx);
          return regex.test(item.toLowerCase());
        });
      }

      postalCodeInputElem.awsomplete.list = that.deliveryAreas;
    } else {
      // some error outputs if street or ares could not be loaded
      /*if (that.streetRecords == null && that.deliveryAreas == null)
                snackbar.show({ message: `${lng.get('form-no-areas-and-no-records')}` });
            else if (that.streetRecords == null)
                snackbar.show({ message: `${lng.get('form-no-street-records')}` });
            else
                snackbar.show({ message: `${lng.get('form-no-delivery-areas')}` });*/
    }
  }

  tr.getData = function () {
    const result = {
      name: data.meta.name,
      data: {
        postalCode: td.querySelector("input[name=postalCode]").value,
        city: td.querySelector("input[name=city]").value,
        street: td.querySelector("input[name=street]").value,
        houseNumber: td.querySelector("input[name=houseNumber]").value,
        houseNumberExtra: td.querySelector("input[name=houseNumberExtra]")
          .value,
      },
    };
    if (data.meta.epaper) {
      result.data.print = td.querySelector('input[name="print"]').checked;
      result.data.epaper = td.querySelector('input[name="epaper"]').checked;
    }
    return result;
  };

  tr.resetElement = function (showElements) {
    if (data.meta.epaper) {
      const printCheckbox = td.querySelector('input[name="print"]');
      const epaperCheckbox = td.querySelector('input[name="epaper"]');

      if (showElements) {
        printCheckbox.parentElement.classList.remove("hide");
        epaperCheckbox.parentElement.classList.remove("hide");
      }

      if (data.meta.required) {
        epaperCheckbox.setCustomValidity(
          "Bitte wählen Sie eines der Felder aus."
        );
        printCheckbox.setCustomValidity(
          "Bitte wählen Sie eines der Felder aus."
        );
      }

      printCheckbox.checked = false;
      epaperCheckbox.checked = false;
    }
  };
}
